export enum EnrollmentReferenceEnum {
  enrollmentQuantityUrban = 500,
  enrollmentQuantityRural = 50,
}
